module.exports = __webpack_public_path__ + "static/img/2.dbcbd61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/2.png
// module id = cWPU
// module chunks = 0